export const MARKERS_SELECT_SET_TYPE = 'MARKERS_SELECT_SET_TYPE';
export const MARKERS_SELECT_RESET = 'MARKERS_SELECT_RESET';
export const MARKERS_SELECT_SAVE = 'MARKERS_SELECT_SAVE';
export const MARKERS_SELECT_ACTIVATE = 'MARKERS_SELECT_ACTIVATE';
export const MARKERS_SELECT_DEACTIVATE = 'MARKERS_SELECT_DEACTIVATE';

export const MARKERS_SELECT_ADD_MARKERS = 'MARKERS_SELECT_ADD_MARKERS';
export const MARKERS_SELECT_REMOVE_MARKERS = 'MARKERS_SELECT_REMOVE_MARKERS';
export const MARKERS_SELECT_SET_LASSO_IS_LOADING = 'MARKERS_SELECT_SET_LASSO_IS_LOADING';
